module.exports = require('./helpers/bundle-url').getBundleURL('bxUMj') + "logo-dark.ba5147f0.svg";